import React from 'react';
import { useJobApplications } from '../../context/JobApplicationContext';
import { HiOutlineFunnel, HiOutlineXMark } from 'react-icons/hi2';
import styles from './FilterPanel.module.css';

const PLATFORMS = [
  'LinkedIn', 'Naukri', 'Company Website', 'Referral', 
  'Indeed', 'Glassdoor', 'AngelList', 'Other'
];

const STATUSES = [
  'Applied', 'Assessment', 'Interview', 'Offer', 'Rejected', 'Ghosted'
];

const PRIORITIES = ['Low', 'Medium', 'High'];

const FilterPanel = () => {
  const { filters, setFilters, fetchApplications } = useJobApplications();

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    fetchApplications(newFilters);
  };

  const clearFilters = () => {
    const clearedFilters = {
      status: '',
      platform: '',
      priority: '',
      dateFrom: '',
      dateTo: '',
      sortBy: 'applied_date',
      sortOrder: 'DESC'
    };
    setFilters(clearedFilters);
    fetchApplications(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters).some(value => 
    value && value !== 'applied_date' && value !== 'DESC'
  );

  return (
    <div className={styles.filterPanel}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <HiOutlineFunnel className={styles.titleIcon} />
          <h3 className={styles.title}>Filters</h3>
        </div>
        {hasActiveFilters && (
          <button onClick={clearFilters} className={styles.clearButton}>
            <HiOutlineXMark className={styles.clearIcon} />
            Clear
          </button>
        )}
      </div>

      <div className={styles.filterGroups}>
        <div className={styles.filterGroup}>
          <label className={styles.label}>Status</label>
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className={styles.select}
          >
            <option value="">All Statuses</option>
            {STATUSES.map(status => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.label}>Platform</label>
          <select
            value={filters.platform}
            onChange={(e) => handleFilterChange('platform', e.target.value)}
            className={styles.select}
          >
            <option value="">All Platforms</option>
            {PLATFORMS.map(platform => (
              <option key={platform} value={platform}>{platform}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.label}>Priority</label>
          <select
            value={filters.priority}
            onChange={(e) => handleFilterChange('priority', e.target.value)}
            className={styles.select}
          >
            <option value="">All Priorities</option>
            {PRIORITIES.map(priority => (
              <option key={priority} value={priority}>{priority}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.label}>Date Range</label>
          <div className={styles.dateRange}>
            <input
              type="date"
              value={filters.dateFrom}
              onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
              className={styles.dateInput}
              placeholder="From"
            />
            <input
              type="date"
              value={filters.dateTo}
              onChange={(e) => handleFilterChange('dateTo', e.target.value)}
              className={styles.dateInput}
              placeholder="To"
            />
          </div>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.filterGroup}>
          <label className={styles.label}>Sort By</label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleFilterChange('sortBy', e.target.value)}
            className={styles.select}
          >
            <option value="applied_date">Applied Date</option>
            <option value="company_name">Company Name</option>
            <option value="role">Role</option>
            <option value="status">Status</option>
            <option value="priority">Priority</option>
            <option value="follow_up_date">Follow-up Date</option>
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.label}>Order</label>
          <select
            value={filters.sortOrder}
            onChange={(e) => handleFilterChange('sortOrder', e.target.value)}
            className={styles.select}
          >
            <option value="DESC">Newest First</option>
            <option value="ASC">Oldest First</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;